<template>
  <batch-upload-attachment
      :attachmentFieldName="attachmentFieldName"
      :batchUploadUrl="batchUploadUrl"
      :checkedItems="checkItems"
      :doQuery="doQuery"
      :modelName="modelName"
      :title="title"
      :uploadUrl="uploadUrl"
      :voName="voName"
  />
</template>

<script>
import BatchUploadAttachment from "@/components/common/attachment/BatchUploadAttachment";
import EmUtils from "@/utils/emUtils";

export default {
  name: "BatchUploadAttachmentWithStore",
  components: {BatchUploadAttachment},
  props: {
    modelName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "批量上传附件"
    },
    attachmentFieldName: {
      type: String,
      required: true
    },
    doQuery: {
      type: Function,
      default: null
    },
    voName: {
      type: String,
      default: 'rows'
    },
  },
  computed: {
    checkItems() {
      return this.$store.state[this.modelName][`checkedItems${EmUtils.toCapFirst(this.voName)}`] || this.$store.state[this.modelName].checkedItems
    },
    batchUploadUrl() {
      return `${this.$store.state[this.modelName].baseModuleUrl}/${this.modelName}/batchUpload/attachment`
    },
    uploadUrl() {
      return process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment"
    },
  }
}
</script>

<style scoped>

</style>
